import {
  hideHeader,
  Modal,
  NavigationConfig,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';
import { MetaGameScreen } from '../screens';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [],
  FULL_SCREEN_MODALS: [
    {
      name: 'MetaGame',
      options: hideHeader,
      component: MetaGameScreen,
    },
  ],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

registerNavigationHandlers<AppNavigatorParamsList, 'MetaGame'>({
  MetaGame(_, { gameType }) {
    Modal.open({
      namespace: 'metaGames',
      type: 'MetaGame',
      data: {
        route: {
          params: { gameType },
        },
      },
      options: {
        hideHeader: true,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        borderRadius: 'radius-400',
      },
    });
  },
});
